// routes

import { BarChart3, Calendar, LayoutDashboard, Users, Users2 } from "lucide-react"

// components

// ----------------------------------------------------------------------
function path(root: string, sublink: string) {
  return `${root}${sublink}`
}

const ROOTS_DASHBOARD = ""

// ----------------------------------------------------------------------

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  time_sheet: {
    root: path(ROOTS_DASHBOARD, "time-sheet"),
    pageTimeSheet: path(ROOTS_DASHBOARD, "time-sheet/check"),
    pageSubmitForm: path(ROOTS_DASHBOARD, "time-sheet/submit"),
    blogs: path(ROOTS_DASHBOARD, "time-sheet/blogs")
  },
  app: {
    root: path(ROOTS_DASHBOARD, "/app")
  },
  admin: {
    root: path(ROOTS_DASHBOARD, "/admin"),
    users: path(ROOTS_DASHBOARD, "/admin/users")
  },
  teams: {
    view: path(ROOTS_DASHBOARD, "/teams"),
    manage: path(ROOTS_DASHBOARD, "/admin/teams")
  }
}

// Notes: icons are rendered as JSX elements and inherit `currentColor` from
// parent styles. Size is constrained by NavSection's ListItemIconStyle (22x22).

interface SidebarItem {
  title: string
  path: string
  icon: JSX.Element
  corporateOnly?: boolean
}

interface SidebarSection {
  subheader: string
  items: SidebarItem[]
}

const sidebarConfig: SidebarSection[] = [
  {
    subheader: "time-sheet",
    items: [
      {
        title: "Bảng Chấm Công",
        path: PATH_DASHBOARD.time_sheet.pageTimeSheet,
        icon: <Calendar />
      },
      {
        title: "Submit form",
        path: PATH_DASHBOARD.time_sheet.pageSubmitForm,
        icon: <LayoutDashboard />
      },
      {
        title: "Blogs",
        path: PATH_DASHBOARD.time_sheet.blogs,
        icon: <BarChart3 />
      }
    ]
  },
  // {
  //   subheader: "teams",
  //   items: [
  //     {
  //       title: "Xem Teams",
  //       path: PATH_DASHBOARD.teams.view,
  //       icon: <Users />
  //     }
  //   ]
  // },
  {
    subheader: "admin",
    items: [
      {
        title: "User Management",
        path: PATH_DASHBOARD.admin.users,
        icon: <Users />,
        corporateOnly: true
      },
      {
        title: "Quản lý Team",
        path: PATH_DASHBOARD.teams.manage,
        icon: <Users2 />,
        corporateOnly: true
      }
    ]
  }
]

export default sidebarConfig
